module.exports = __webpack_public_path__ + "static/media/ellam-unselected.7bfe7057.png";